import React, { useState, useEffect, useCallback } from "react";
import "./Memarts.css"; // We'll create this CSS file separately

const Memarts = () => {
  // ---------- ДАННЫЕ УРОКОВ (масштабируемая структура) ----------
  const lessons = {
    1: {
      1: {
        title: "Word list Lvl 1 Lesson 1",
        words: [
          // Существительные (12)
          { english: "a man - men", russian: "мужчина - мужчины" },
          { english: "a woman - women", russian: "женщина - женщины" },
          { english: "a child - children", russian: "ребёнок - дети" },
          { english: "a person - people", russian: "человек - люди" },
          { english: "a plant - plants", russian: "растение - растения" },
          { english: "a tree - trees", russian: "дерево - деревья" },
          { english: "a flower - flowers", russian: "цветок - цветы" },
          {
            english: "an animal - animals",
            russian: "животное - животные",
          },
          { english: "a bird - birds", russian: "птица - птицы" },
          { english: "a thing - things", russian: "вещь - вещи" },
          {
            english: "an object - objects",
            russian: "предмет - предметы",
          },
          { english: "a place - places", russian: "место - места" },
          // Слово "Adjectives" как отдельная карточка
          { english: "Adjectives", russian: "Прилагательные" },
          // Прилагательные (39)
          { english: "friendly", russian: "дружелюбный" },
          { english: "unfriendly", russian: "недружелюбный" },
          { english: "kind", russian: "добрый" },
          { english: "angry", russian: "злой" },
          {
            english: "great",
            russian: "великий, потрясающий, замечательный",
          },
          { english: "new", russian: "новый" },
          { english: "young", russian: "молодой" },
          { english: "old", russian: "старый" },
          { english: "clean", russian: "чистый" },
          { english: "dirty", russian: "грязный" },
          { english: "cute", russian: "миленький, хорошенький" },
          {
            english: "nosy",
            russian: "любопытный, сующий свой нос везде",
          },
          { english: "interesting", russian: "интересный" },
          { english: "boring", russian: "скучный" },
          { english: "funny", russian: "забавный, смешной" },
          { english: "beautiful", russian: "красивый, прекрасный" },
          { english: "active", russian: "активный" },
          { english: "lazy", russian: "ленивый" },
          { english: "crazy", russian: "сумасшедший" },
          { english: "free", russian: "свободный; бесплатный" },
          { english: "busy", russian: "занятой" },
          {
            english: "simple",
            russian:
              "1. простой, легкий (не требующий много усилий при выполнении) 2. простой (выполненный без каких-либо излишеств)",
          },
          {
            english: "difficult",
            russian: "трудный (в выполнении или понимании)",
          },
          { english: "easy", russian: "простой, легкий" },
          { english: "hard", russian: "трудный, сложный" },
          { english: "fat", russian: "толстый; жирный" },
          { english: "slim", russian: "худой, стройный" },
          { english: "nice", russian: "милый, приятный" },
          { english: "small", russian: "маленький" },
          {
            english: "little",
            russian: "маленький по возрасту или количеству",
          },
          { english: "large", russian: "очень большой" },
          { english: "excellent", russian: "превосходный" },
          { english: "stupid", russian: "глупый, неразумный" },
          { english: "weak", russian: "слабый" },
          { english: "rich", russian: "богатый" },
          { english: "poor", russian: "бедный" },
          { english: "mean", russian: "подлый, скупой, недобрый" },
          { english: "light", russian: "лёгкий (по весу)" },
          { english: "heavy", russian: "тяжёлый (по весу)" },
        ],
      },
      2: {
        title: "Word list Lvl 1 Lesson 2",
        words: [
          { english: "in/at the office", russian: "в офисе" },
          { english: "in/at the classroom", russian: "в классе" },
          { english: "in/at the restaurant", russian: "в ресторане" },
          { english: "in/at the cafe", russian: "в кафе" },
          { english: "in/at the cottage", russian: "в коттедже" },
          { english: "in/at the swimming pool", russian: "в бассейне" },
          { english: "in/at the post office", russian: "на почте" },
          { english: "in/at the hospital", russian: "в больнице" },
          { english: "in the mountains", russian: "в горах" },
          { english: "in America", russian: "в Америке" },
          {
            english: "in Saint Petersburg",
            russian: "в Санкт-Петербурге",
          },
          { english: "in the village", russian: "в деревне" },
          {
            english: "in the country",
            russian: "за городом / в сельской местности",
          },
          { english: "in the city", russian: "в городе" },
          { english: "in the park", russian: "в парке" },
          { english: "at the party", russian: "на вечеринке" },
          { english: "at the concert", russian: "на концерте" },
          { english: "at the spa", russian: "в спа" },
          { english: "at the lesson", russian: "на уроке" },
          { english: "at the meeting", russian: "на встрече" },
          { english: "at the theatre", russian: "в театре" },
          { english: "at the university", russian: "в университете" },
          { english: "at work", russian: "на работе" },
          { english: "at school", russian: "в школе" },
          { english: "at home", russian: "дома" },
          { english: "in church", russian: "в церкви" },
          { english: "in prison", russian: "в тюрьме" },
          { english: "abroad", russian: "за границей" },
          { english: "near", russian: "рядом, близко" },
          { english: "far (from)", russian: "далеко (от)" },
          {
            english: "in the street (UK) / on the street (US)",
            russian: "на улице",
          },
        ],
      },
    },
  };

  // ---------- СОСТОЯНИЕ ----------
  const [currentLevel, setCurrentLevel] = useState(1);
  const [currentLesson, setCurrentLesson] = useState(1);
  const [deck, setDeck] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [englishFirstMode, setEnglishFirstMode] = useState(true);

  // ---------- ЭФФЕКТЫ ----------
  useEffect(() => {
    loadLesson();
  }, [currentLevel, currentLesson]);

  useEffect(() => {
    updateDocumentTitle();
  }, [currentLevel, currentLesson, deck]);

  // ---------- ФУНКЦИИ ----------
  const getCurrentLessonData = useCallback(() => {
    return lessons[currentLevel]?.[currentLesson];
  }, [currentLevel, currentLesson]);

  const loadLesson = () => {
    const lessonData = getCurrentLessonData();
    if (!lessonData) return;

    setDeck([...lessonData.words]);
    setCurrentIndex(0);
    setEnglishFirstMode(true);
    setIsFlipped(false);
  };

  const updateDocumentTitle = () => {
    const lessonData = getCurrentLessonData();
    if (lessonData) {
      document.title = `Карточки · ${lessonData.words.length} слов · Lvl ${currentLevel} Lesson ${currentLesson}`;
    }
  };

  const handleCardClick = () => {
    if (!isFlipped) {
      setIsFlipped(true);
    } else {
      nextCard();
    }
  };

  const nextCard = () => {
    setCurrentIndex((prev) => (prev + 1) % deck.length);
    setIsFlipped(false);
  };

  const shuffleDeck = () => {
    if (deck.length <= 1) return;

    const shuffled = [...deck];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    setDeck(shuffled);
    setCurrentIndex(0);
    setIsFlipped(false);
  };

  const switchLanguageMode = () => {
    setEnglishFirstMode((prev) => !prev);
    setIsFlipped(false); // Reset flip state when switching language mode
  };

  const switchLesson = (lessonNum) => {
    if (lessons[currentLevel]?.[lessonNum]) {
      setCurrentLesson(lessonNum);
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight" || e.key === " ") {
        e.preventDefault();
        if (!isFlipped) {
          setIsFlipped(true);
        } else {
          nextCard();
        }
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        setCurrentIndex((prev) => (prev - 1 + deck.length) % deck.length);
        setIsFlipped(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isFlipped, deck.length]);

  // Получить текущие данные карточки
  const currentWord = deck[currentIndex];

  // Получить все номера уроков для навигации
  const lessonNumbers = Object.keys(lessons[currentLevel] || {})
    .map(Number)
    .sort((a, b) => a - b);

  // ---------- РЕНДЕР ----------
  return (
    <div className='deck-container'>
      <h1>
        Word list Lvl <span>{currentLevel}</span> Lesson{" "}
        <span>{currentLesson}</span>
      </h1>
      <div className='subtitle'>
        👆 нажми на слово → перевод → ещё раз → следующее
      </div>

      {/* Lesson navigation buttons */}
      <div className='lesson-nav'>
        {lessonNumbers.map((lessonNum) => (
          <button
            key={lessonNum}
            className={`lesson-btn ${
              currentLesson === lessonNum ? "active" : ""
            }`}
            onClick={() => switchLesson(lessonNum)}
          >
            Lesson {lessonNum}
          </button>
        ))}
      </div>

      <div className='counter-header'>
        <span className='counter'>
          {deck.length > 0 ? `${currentIndex + 1} / ${deck.length}` : "0 / 0"}
        </span>
      </div>

      <div className='card-wrapper'>
        <div
          className={`card ${isFlipped ? "flipped" : ""}`}
          onClick={handleCardClick}
        >
          <div className='card-inner'>
            <div className='card-front'>
              {currentWord && (
                <>
                  <div className='word'>
                    {englishFirstMode
                      ? currentWord.english
                      : currentWord.russian}
                  </div>
                  <div className='badge'>{englishFirstMode ? "EN" : "RU"}</div>
                </>
              )}
            </div>
            <div className='card-back'>
              {currentWord && (
                <>
                  <div className='word'>
                    {englishFirstMode
                      ? currentWord.russian
                      : currentWord.english}
                  </div>
                  <div className='badge'>{englishFirstMode ? "RU" : "EN"}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='controls-panel'>
        <button className='ctrl-btn' onClick={shuffleDeck}>
          Shuffle
        </button>
        <button className='ctrl-btn' onClick={switchLanguageMode}>
          {englishFirstMode ? "EN → RU" : "RU → EN"}
        </button>
      </div>
    </div>
  );
};

export default Memarts;
